import * as React from "react";
import { SVGProps } from "react";

const Celsius = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 57 57"
    {...props}
  >
    <style>{".st0{fill:#262761}"}</style>
    <g id="Page-1">
      <g id="Celsius_Website_Logo_Filled">
        <circle id="Oval" cx={43.3} cy={22.5} r={1.4} className="st0" />
        <path
          id="Shape"
          d="M28.9 0C12.9 0 0 12.9 0 28.9s12.9 28.9 28.9 28.9 28.9-12.9 28.9-28.9S44.8 0 28.9 0zM42 40.9c-3.4 3.8-8.3 5.9-13.3 5.9-5.1 0-10-2.2-13.4-6-3.5-3.9-5-8.8-4.5-14 .9-8.3 7.5-14.9 15.8-15.9.7-.1 1.4-.1 2.1-.1 4 0 7.8 1.3 11 3.8.2.1.3.4.3.6 0 .3-.1.5-.3.7l-1.9 1.7c-.2.2-.5.3-.8.3-.2 0-.5-.1-.6-.2-2.3-1.6-5-2.4-7.7-2.4-3.9 0-7.6 1.7-10.1 4.6-2.6 2.9-3.8 6.7-3.3 10.6.7 6.2 5.7 11.2 11.9 11.9.5.1 1 .1 1.6.1 3.6 0 7-1.4 9.6-4 .2-.2.5-.3.8-.3.2 0 .4.1.6.2l2.1 1.4c.2.1.3.3.4.6-.1.1-.2.3-.3.5zm1.3-14c-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4c2.4 0 4.4 2 4.4 4.4s-2 4.4-4.4 4.4z"
          className="st0"
        />
      </g>
    </g>
  </svg>
);

export default Celsius;
